import { escapeSql } from '@rdrive/helper-sql';
import { makeChartConfig } from '@rdrive/helper-chart-config';
import { teamAssigneeColumn } from '../../data/filters.js';

// Issue distribution by assigned team, for @rdrive/plugin-chart-donut's BaseDonutChart
// (IA_ABSORPTION_PLAN Phase 4 step 12b; was components/charts/AssignedTeamDonutChart.vue, whose
// query strings these are). Rendered `bare` in the Analysis page's Responsible Party / Assigned
// Team card. Slices are keyed by team NAME, as before (two teams with one name are one slice).
export function useAssignedTeamDonutChart({ chartName, filterContext, conn }) {
  const { ctx, rows: run, applyFilter, removeFilter } = makeChartConfig({ chartName, filterContext, conn });

  // Rows for the donut: { teamId, name, value } — `teamId` is the slice key the base hashes for the
  // colour and hands back to setAssignedTeamFilter; here it is the team name (null for an assignee
  // id that matches no team: the "Unassigned" slice, which does not filter).
  // `filteredIssues.issueAssignee` is the detected team-assignee column (data/filters.js).
  const getAssignedTeamDistribution = async () => {
    const rows = await run(`
    SELECT 
      t.Name AS assignedTeam,
      COUNT(*) AS value
    FROM filteredIssues fi
    LEFT JOIN teams t ON fi.issueAssignee = t.Id
    WHERE fi.issueAssignee IS NOT NULL AND fi.issueAssignee != ''
    GROUP BY t.Name
    ORDER BY value DESC
  `);

    return rows.map((row) => ({
      teamId: row.assignedTeam,
      name: row.assignedTeam || 'Unassigned',
      value: Number(row.value),
    }));
  };

  // null clears this chart's filter registration. The `issues` column is the one `filteredIssues`
  // exposes as `issueAssignee`, from the context's last detection (data/filters.js
  // `teamAssigneeColumn`; since IA_ABSORPTION_PLAN step 13 — it read `IssueAssignee` for a new-API
  // table without `IssueUserAssignees`, which that table does not have, so the filter failed).
  const setAssignedTeamFilter = async (assignedTeam) => {
    if (!assignedTeam) {
      await removeFilter();
      return;
    }
    const teamAssigneeCol = teamAssigneeColumn(ctx());
    await applyFilter(`
      SELECT DISTINCT i.id
      FROM issues i
      LEFT JOIN teams t ON i.${teamAssigneeCol} = t.Id
      WHERE t.Name = '${escapeSql(assignedTeam)}'
    `);
  };

  return { getAssignedTeamDistribution, setAssignedTeamFilter };
}
